import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    currentCheckout: {},
    currentDeliveryInfo: null,
    orderStatus : [],
    reviewStatus : [],
    // commandes « En attente traitement » (alerte du menu)
    pendingOrdersCount: 0,
    currentProductPlaces: {
        shops: [],
        stores: []
    }
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
